import { jsx as o, jsxs as m } from "react/jsx-runtime";
import { chakra as n, Button as p } from "@chakra-ui/react";
import { n as d } from "../../floating-ui.react-5e63cf1f.js";
import { useLocationPickerStyle as f, useLocationPickerContext as _ } from "./LocationPicker.context.es.js";
const P = () => {
  const e = f(), { isOpen: r, refs: i, floatingStyles: c, getFloatingProps: a, suggestions: l, onItemClick: s } = _();
  return r ? /* @__PURE__ */ o(d, { children: /* @__PURE__ */ o(
    n.div,
    {
      __css: { ...e.content },
      ref: i.setFloating,
      style: c,
      ...a(),
      children: l.map((t) => /* @__PURE__ */ m(
        p,
        {
          __css: { ...e.item },
          onClick: () => s(t),
          variant: "unstyled",
          children: [
            /* @__PURE__ */ o("b", { children: t.name }),
            !!t.place_formatted && /* @__PURE__ */ o(n.span, { children: t.place_formatted })
          ]
        },
        t.mapbox_id
      ))
    }
  ) }) : null;
};
export {
  P as LocationPickerComponent
};
//# sourceMappingURL=LocationPicker.component.es.js.map
